<template>
  <span v-if="!loading" class="my-space-hero-summary-widget">
    <span v-for="item in items" :key="item.key" v-if="item.count" class="my-space-hero-chip" @click="goTasks"><AppIcon :name="item.icon" />{{ item.count }} {{ item.label }}</span>
  </span>
</template>
<script>
import serviceTasks from '../staff/services'
import ErrorToken from '@/handler/errorToken'
import { EventBus } from '@/handler/event-bus'
export default {
  name: 'MySpaceTasksSummaryWidget',
  data: () => ({ loading: true, counts: { personal: 0, customers: 0, suppliers: 0, projects: 0 } }),
  computed: {
    items() { return [
      { key: 'personal', icon: 'person', count: this.counts.personal, label: this.counts.personal === 1 ? 'tarea personal' : 'tareas personales' },
      { key: 'customers', icon: 'business', count: this.counts.customers, label: this.counts.customers === 1 ? 'tarea cliente' : 'tareas clientes' },
      { key: 'suppliers', icon: 'local_shipping', count: this.counts.suppliers, label: this.counts.suppliers === 1 ? 'tarea proveedor' : 'tareas proveedores' },
      { key: 'projects', icon: 'folder', count: this.counts.projects, label: this.counts.projects === 1 ? 'tarea proyecto' : 'tareas proyectos' },
    ] },
  },
  mounted() { EventBus.$on('MySpace:tasks-refresh', this.load); this.load() },
  beforeDestroy() { EventBus.$off('MySpace:tasks-refresh', this.load) },
  methods: {
    load() { serviceTasks.obtenerOpciones({ completion_status: 'pending' }).then(response => { var mine = ((response.data || {}).context_counts || {}).mine || {}; this.counts = { personal: Number(mine.personal || 0), customers: Number(mine.customers || 0), suppliers: Number(mine.suppliers || 0), projects: Number(mine.projects || 0) }; this.loading = false }).catch(error => { this.loading = false; this.$awn.alert(ErrorToken.valid(error)) }) },
    goTasks() { this.$router.push({ name: 'TasksStaffCrud', query: { context: 'mine' } }).catch(() => {}) },
  },
}
</script>
